module.exports = __webpack_public_path__ + "img/shutters-single.fc64145b.svg";